import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
// import { getError } from "../utils/errors"

const urlCategory = "Category";

//* Metodo para obtener categorias de paquetes
export const getDestinos = async () => {
    return await axios.get(
        `${APIURL}/${urlCategory}/find`, {
        headers: getCabecera(),
    }
    ).then((Response) => {
        return Response.data;
    }).catch((Error => {
        return [];
    }))
}